import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";import graphql from 'babel-plugin-relay/macro'
import {useEffect} from 'react'
import { usePreloadedQuery} from 'react-relay'

import useAtmosphere from '../hooks/useAtmosphere'
import useDocumentTitle from '../hooks/useDocumentTitle'
import useMutationProps from '../hooks/useMutationProps'
import useRouter from '../hooks/useRouter'
import AcceptTeamInvitationMutation from '../mutations/AcceptTeamInvitationMutation'
import PushInvitationMutation from '../mutations/PushInvitationMutation'
import DialogContent from './DialogContent'
import DialogTitle from './DialogTitle'
import Ellipsis from './Ellipsis/Ellipsis'
import InvitationCenteredCopy from './InvitationCenteredCopy'
import InvitationDialogCopy from './InvitationDialogCopy'
import InviteDialog from './InviteDialog'
import PrimaryButton from './PrimaryButton'
import TeamInvitationWrapper from './TeamInvitationWrapper'





const query = graphql`
  query ViewerNotOnTeamQuery($teamId: ID, $meetingId: ID) {
    viewer {
      teamInvitation(teamId: $teamId, meetingId: $meetingId) {
        teamInvitation {
          token
        }
        teamId
        meetingId
      }
    }
  }
`

const ViewerNotOnTeam = (props) => {
  const {queryRef} = props
  const data = usePreloadedQuery(query, queryRef)
  const {viewer} = data
  const {
    teamInvitation: {teamInvitation, meetingId, teamId}
  } = viewer
  const atmosphere = useAtmosphere()
  const {history} = useRouter()
  const {onError, onCompleted} = useMutationProps()
  useDocumentTitle(`Invitation Required`, 'Invitation Required')
  useEffect(() => {
    if (teamInvitation) {
      // if an invitation already exists, accept it
      AcceptTeamInvitationMutation(
        atmosphere,
        {invitationToken: teamInvitation.token},
        {history, meetingId}
      )
      return
    } else if (teamId)
      PushInvitationMutation(atmosphere, {meetingId, teamId}, {onError, onCompleted})
    return undefined
  }, [])

  if (teamInvitation) return null
  return (
    _jsx(TeamInvitationWrapper, { children: 
      _jsxs(InviteDialog, { children: [
        _jsx(DialogTitle, { children: "Invitation Required" })
        , _jsxs(DialogContent, { children: [
          _jsx(InvitationDialogCopy, { children: "You’re almost on the team!"    })
          , _jsx(InvitationDialogCopy, { children: "Just ask a team member for an invitation."       })
          , _jsx(InvitationDialogCopy, { children: "This page will redirect automatically."    })
          , _jsx(InvitationCenteredCopy, { children: 
            _jsxs(PrimaryButton, { size: "medium", waiting: true, children: [
              _jsx('span', { children: "Waiting for Invitation"  })
              , _jsx(Ellipsis, {} )
            ]})
          })
        ]})
      ]})
    })
  )
}

export default ViewerNotOnTeam
